import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'what_average_time_days_it_takes_reach_outcome'

export const dataPointDefinition = {
  retracedId: 'what_average_time_days_it_takes_reach_outcome',
  name: 'What is the average time in days it takes to reach an outcome on a grievance?',
  description:
    'Please calculate the average time a complaint takes from submission to outcome by summing all the time (in days) each complaint took and dividing by the total number of complaints.',
  meta: {
    slcpMeta: {
      key: 'wi-gri-40',
      number: 'WI-GRI-30',
      masterType: 'Question',
      versionImported: '1.7.0',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'wi-gri-40', version: '1.7.0', provider: 'slcp'}],
  sortingId: 36860,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
